import { render } from "./BaseFormInput.vue?vue&type=template&id=86b246e2&scoped=true"
import script from "./BaseFormInput.vue?vue&type=script&lang=js"
export * from "./BaseFormInput.vue?vue&type=script&lang=js"

import "./BaseFormInput.vue?vue&type=style&index=0&id=86b246e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86b246e2"]])

export default __exports__